import Vue from 'vue'
import Router from 'vue-router'
// 后台管理系统
import admin from './modules/admin'
import front from './modules/front'
import preview from './modules/preview'
import htmlSplit from './modules/htmlSplit'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    ...admin,
    ...front,
    ...preview,
    ...htmlSplit
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js